import Avatar from '@components/common/avatar'
import { SUPPORT_WHATSAPP_NUMBER } from '@lib/constants/common'
import { RelationshipManagerType } from '@lib/types/common'
import { Mail, Phone } from 'react-feather'
import { WhatsappIcon } from 'react-share'

type Props = {
  relationshipManager: RelationshipManagerType
}

const RMDetails = ({ relationshipManager }: Props) => {
  if (!relationshipManager) return null
  return (
    <div className="flex flex-col p-4 overflow-hidden rounded-lg bg-grey-100">
      <p className="mb-3 font-600">Relationship Manager details</p>
      <div className="flex items-center">
        <Avatar image={relationshipManager.avatar} isNotCurrentUser />
        <span className="ml-3 font-500">{relationshipManager.name}</span>
      </div>
      <div className="flex flex-wrap ml-1">
        <a
          href={`tel:${SUPPORT_WHATSAPP_NUMBER.courseClass.value}`}
          className="flex items-center mt-3 mr-3 group"
        >
          <span className="flex items-center justify-center w-6 h-6 bg-orange-200 rounded-full">
            <Phone className="text-orange" size={14} />
          </span>
          <span className="ml-2 text-grey group-hover:underline group-hover:text-orange">
            {SUPPORT_WHATSAPP_NUMBER.courseClass.label}
          </span>
        </a>
        <a
          href={`mailto:${relationshipManager.email}`}
          className="flex items-center mt-3 group"
        >
          <span className="flex items-center justify-center w-6 h-6 bg-orange-200 rounded-full">
            <Mail className="text-orange" size={14} />
          </span>
          <span className="ml-2 text-grey group-hover:underline group-hover:text-orange">
            {relationshipManager.email}
          </span>
        </a>
        <a
          href={`https://wa.me/${SUPPORT_WHATSAPP_NUMBER.courseClass.value}`}
          target="_blank"
          rel="noreferrer"
          className="flex items-center mt-3 group"
        >
          <span className="flex items-center justify-center w-6 h-6 bg-orange-200 rounded-full">
            <WhatsappIcon
              round
              bgStyle={{ fill: '#FFEDEB' }}
              iconFillColor="#FF5A43"
            />
          </span>
          <span className="ml-2 text-grey group-hover:underline group-hover:text-orange">
            {SUPPORT_WHATSAPP_NUMBER.courseClass.label}
          </span>
        </a>
      </div>
    </div>
  )
}

export default RMDetails
